import type { Banner, Testimonial } from '@/types';

export const banners: Banner[] = [
  {
    id: 'ban_hero', placement: 'HERO', eyebrow: 'New season · Just landed',
    title: 'Premium Quality For a Better Tomorrow',
    subtitle: 'Discover top products at the best prices. Shop smarter, live better.',
    cta: { label: 'Shop Now', to: '/products' }, secondaryCta: { label: 'View Offers', to: '/offers' },
    hue: 245, icon: 'headphones',
  },
  {
    id: 'ban_summer', placement: 'PROMO', eyebrow: 'Summer Sale',
    title: 'Up to 50% Off', subtitle: 'On selected footwear, fitness and lifestyle picks.',
    cta: { label: 'Shop Now', to: '/categories/sports' }, hue: 262, icon: 'footprints',
  },
  {
    id: 'ban_audio', placement: 'PROMO', eyebrow: 'Special Offer',
    title: 'Sound Like Never Before', subtitle: 'Headphones, earbuds and speakers with up to 40% off.',
    cta: { label: 'Explore Audio', to: '/categories/electronics' }, hue: 222, icon: 'headphones',
  },
  {
    id: 'ban_deal_1', placement: 'DEAL', eyebrow: 'Big Deals, Bigger Smiles',
    title: 'Up to 70% Off', subtitle: 'Limited-time prices across electronics, fashion and home.',
    cta: { label: 'Shop Now', to: '/products?onSale=1' }, hue: 22, icon: 'watch',
  },
  {
    id: 'ban_deal_2', placement: 'DEAL', eyebrow: 'Home refresh',
    title: 'Flat 30% Off Home & Living', subtitle: 'Lighting, bedding and decor to make your space yours.',
    cta: { label: 'Refresh Home', to: '/categories/home-living' }, hue: 35, icon: 'lamp',
  },
];

export const testimonials: Testimonial[] = [
  { id: 't1', name: 'Rahul Sharma', city: 'Mumbai', rating: 5, quote: 'Ordered headphones on Monday, had them by Wednesday. Packaging was superb and the sound quality is unreal for the price.' },
  { id: 't2', name: 'Priya Nair', city: 'Bengaluru', rating: 5, quote: 'Loving the wallet cashback and reward points — I have already saved enough for my next order.' },
  { id: 't3', name: 'Ankit Verma', city: 'Delhi', rating: 4, quote: 'Clean site, easy checkout, and the return process was painless when I needed a different size.' },
];

export const benefits = [
  { icon: 'truck', title: 'Free Shipping', text: 'On orders above ₹999' },
  { icon: 'shield', title: 'Cash on delivery', text: 'Card and UPI are not connected' },
  { icon: 'headset', title: 'Store support', text: 'Write to the store from Contact' },
  { icon: 'rotate', title: 'Returns', text: 'Request one after the order is delivered' },
] as const;
